<template>
    <div class="bg-gray-200 flex items-center justify-between py-1 px-2 cursor-pointer" @click="emit('toggle-group')">
        <div>
            <span>{{ group.name }}</span>
            <span class="text-gray-500 ml-1">({{ selectedStudents.length }} / {{ group.students.length }})</span>
        </div>
        <svg class="-mr-1 ml-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" :class="collapsed ? '-rotate-90' : ''">
            <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
            />
        </svg>
    </div>

    <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
    >
        <div v-show="collapsed" class="mt-1">
            <div>
                <SelectAllNoneButtons
                    :max-count="2"
                    :selected-count="1"
                    @select-all="selectAll()"
                    @select-none="deselectAll()"
                    class="flex"
                />
            </div>
            <TransitionGroup
                enter-active-class="transition-opacity ease-linear duration-300"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition-opacity ease-linear duration-300"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
                tag="div"
                class=""
            >
                <div v-for="student in filteredStudents" :key="student.id">
                    <div class="cursor-pointer flex space-x-2 items-center">
                        <label>
                            <input
                                type="checkbox"
                                v-model="studentIds"
                                name="student_ids[]"
                                :value="student.id"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            <span class="pl-1"> {{ student.full_name }}</span>
                        </label>

                        <div class="flex space-x-1 items-center">
                            <BadgePill v-for="tag in student.tags" color="indigo" :key="tag">
                                {{ tag }}
                            </BadgePill>
                        </div>
                    </div>
                </div>
            </TransitionGroup>
        </div>
    </transition>
</template>

<script>
import SelectAllNoneButtons from '@/components/SelectAllNoneButtons.vue';
import BadgePill from '@/components/BadgePill.vue';

export default {
    name: 'StudentBatchSelectorGroup',
    components: {
        SelectAllNoneButtons,
        BadgePill,
    },
};
</script>
<script setup>
import { useVModel } from '@vueuse/core';
import { pullAll, union } from 'lodash';
import { computed } from 'vue';
import deburr from 'lodash/deburr.js';
let emit = defineEmits(['update:modelValue', 'toggleGroup']);
const props = defineProps({
    modelValue: {
        type: Array,
        required: true,
    },
    group: {
        type: Object,
        required: true,
    },
    collapsed: {
        type: Boolean,
        required: true,
    },
    search: {
        type: String,
        required: true,
    },
});

const selectAll = () => {
    const ids = props.group.students.map((s) => s.id);
    studentIds.value = union(studentIds.value, ids);
};
const deselectAll = () => {
    const ids = props.group.students.map((s) => s.id);
    pullAll(studentIds.value, ids);
};

const studentIds = useVModel(props, 'modelValue', emit);
const filteredStudents = computed(() => {
    if (props.search.trim() === '') {
        return props.group.students;
    }

    const searchUpperCase = deburr(props.search.toUpperCase());

    return props.group.students.filter((s) => {
        const fullName = deburr(s.full_name.toUpperCase());
        if (fullName.includes(searchUpperCase)) {
            return true;
        }
    });
});
const selectedStudents = computed(() => {
    return props.group.students.filter((s) => {
        return studentIds.value.includes(s.id);
    });
});
</script>
